import { I18nConfig, TranslationChunksConfig, TranslationResources } from '@spartacus/core';

export const customProduct = {
  customProductDetails: {
    priceFrom: 'от {{price}}',
    addedToCart: 'В корзине: {{count}} {{unitName}}',
    subTitle: '{{count}} товар',
    subTitle_few: '{{count}} товара',
    subTitle_many: '{{count}} товаров',
  },
  customProductAvailability: {
    availabilityInShops: 'в магазинах {{nameGenitive}}',
    deliver: {
      inHours: 'через {{ count }} час',
      inHours_few: 'через {{ count }} часа',
      inHours_many: 'через {{ count }} часов',
      tomorrow: 'завтра',
      afterTomorrow: 'послезавтра',
    },
    shops: '{{ count }} магазин',
    shops_few: '{{ count }} магазина',
    shops_many: '{{ count }} магазинов',
  },
  customProductBuyBlock: {
    addedToCart: '{{count}} {{unitName}} в корзине',
    sumInCart: 'на сумму <b>{{sum}}</b>',
    saleMultiples: 'Товар продается кратно {{count}} {{unitName}}',
    orderMinimum: 'Покупка от {{count}} {{unitName}}',
  },
  productCalculator: {
    price: '({{price}} ₽)',
  },
  productTransitPrice: {
    unit: 'Цена за {{count}} {{unitName}}',
    multiplicity: 'Количество товара в заявке должно быть кратно {{count}} {{unitName}}',
  },

  /**
   * Регистр ProductDetailComponentContainer и структуру нельзя менять,
   * такова реализация projects/storefrontlib/src/cms-components/content/tab-paragraph-container/tab-paragraph-container.component.ts
   * */
  ProductDetailComponentContainer: {
    tabs: {
      ProductDetailsTabComponent: 'Описание',
      CrossSelling: 'Сопутствующие товары',
      ProductSpecsTabComponent: 'Характеристики',
      ProductArticlesTabComponent: 'Статьи',
      CalculatorComponent: 'Калькулятор расчета',
      ProductShopAvailabilityTabComponent: 'Наличие в магазинах',
      ProductDataSheetTabComponent: 'Документация',
      Similar: 'Похожие товары',
      ProductReviewsTabComponent: 'Отзывы',
    },
  },
};

const ru = {
  customProduct,
};

const productTranslations: TranslationResources = {
  ru,
};

const productTranslationChunksConfig: TranslationChunksConfig = {
  customProduct: [
    'customProductDetails',
    'customProductBuyBlock',
    'customProductAvailability',
    'productCalculator',
    'productTransitPrice',
    'ProductDetailComponentContainer',
  ],
};

export const productI18nConfig: I18nConfig = {
  i18n: {
    resources: productTranslations,
    chunks: productTranslationChunksConfig,
  },
};
